const variableModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl: '/modules/pis-tool/routes/variable-modal/variable-modal.html',
  controller: 'VariableModalController',
};

angular
  .module('pis-tool.module')
  .component('variableModal', variableModal);
